import React from 'react'
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons'
import ListView from './ServicesTable'
import { ContainerCard } from '../../../reusable-components/AgiliteCards'
import PageHeader from '../../../reusable-components/PageHeader'

const ServicesWrapper = () => {
  return (
    <ContainerCard bodyStyle={{ padding: 0 }}>
      <PageHeader title='Services Management' icon={faCalendarCheck} />
      <ListView />
    </ContainerCard>
  )
}

export default ServicesWrapper
